import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import FilterPageComponent from "../../Components/FilterPageComponent/FilterPageComponent";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  secretKey,
  stringifyData,
} from "../utils/page";
import axios from "axios";
import CryptoJS from "crypto-js";

const FilterPage = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [filtersByCategory, setFiltersByCategory] = useState();
  const [dataByCategory, setDataByCategory] = useState();
  const [loading, setLoading] = useState("");
  const [categorySelected, setCategorySelected] = useState();
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [categoriesData, setcategoriesData] = useState();
  const handleGetCategory = () => {
    const option = {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Product/GetCategoriesFromProduct`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setcategoriesData(data);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    handleGetCategory();
  }, []);

  const [filters, setFilters] = useState({
    PageNumber: 1,
    PageSize: 18,
    LowestPrice: null,
    HighestPrice: null,
    BrandNames: [],
    VendorIds: [],
    IsProductInOffer: null,
    IsStockAvailable: null,
    CategoryId: null,
    ThisWeek: null,
    ThisMonth: null,
    HighToLow: null,
    LowToHigh: null,
  });

  const GetAllFiltersByCategory = (i) => {
    const urlId = decodeURIComponent(window.location.pathname?.split("/")?.[2]); // Decode URL
    // const urlId = decodeURIComponent(window.location.hash?.split("/")?.[2]); // Decode URL
    const bytes = CryptoJS.AES.decrypt(urlId, secretKey());
    const originalId = bytes.toString(CryptoJS.enc.Utf8);
    const data = {
      id: i?.Id || originalId,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/GetAllFiltersByCategory`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setFiltersByCategory(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const GetProductsByFilter = (customFilters) => {
    const filtersToUse = customFilters || filters;
    const data = {
      PageNumber: filtersToUse?.PageNumber,
      PageSize: filtersToUse?.PageSize,
      PriceFrom:
        filters?.LowestPrice != null ? filters.LowestPrice.toString() : null,
      PriceTo:
        filters?.HighestPrice != null ? filters.HighestPrice.toString() : null,
      BrandNames: filtersToUse?.BrandNames,
      VendorIds: filtersToUse?.VendorIds,
      IsProductInOffer: filtersToUse?.IsProductInOffer,
      IsStockAvailable: filtersToUse?.IsStockAvailable,
      CategoryId: filtersToUse?.CategoryId,
      ThisWeek: filtersToUse?.ThisWeek,
      ThisMonth: filtersToUse?.ThisMonth,
      HighToLow: filtersToUse?.HighToLow,
      LowToHigh: filtersToUse?.LowToHigh,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/GetProductsByFilter`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setDataByCategory(data);
      })
      .catch((error) => {});
  };

  const handleCategorySelect = (i) => {
    const urlId = decodeURIComponent(window.location.pathname?.split("/")?.[2]); // Decode URL
    // const urlId = decodeURIComponent(window.location.hash?.split("/")?.[2]); // Decode URL
    const bytes = CryptoJS.AES.decrypt(urlId, secretKey());
    const originalId = bytes.toString(CryptoJS.enc.Utf8);
    setLoading("category");
    setFilters((prev) => ({
      ...prev,
      CategoryId: originalId,
    }));
    setCategorySelected(i?.Id || originalId);
    const data = {
      Id: i?.Id || originalId,
      PageNumber: "1",
      PageSize: "18",
    };
    const option = {
      method: "Post",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Product/GetProductsByCategories`,
      data: stringifyData(data),
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setDataByCategory(data);
        setLoading("");
      })
      .catch((error) => {});
  };
  useEffect(() => {
    handleCategorySelect();
    GetAllFiltersByCategory();
  }, []);
  const isAnyFilterActive = () => {
    return (
      
      filters.BrandNames.length > 0 ||
      filters.VendorIds.length > 0 ||
      filters.IsProductInOffer !== null ||
      filters.IsStockAvailable !== null ||
      filters.ThisWeek !== null ||
      filters.ThisMonth !== null ||
      filters.HighToLow !== null ||
      filters.LowToHigh !== null
    );
  };
  const handleClearAll = () => {
    // Set filters state to reset the selected filters
    setFilters((prev) => ({
      ...prev,
      LowestPrice: null, // Set LowestPrice to LowestPrice from filtersByCategory
      HighestPrice: null, // Set HighestPrice to HighestPrice from filtersByCategory
      BrandNames: [], // Clear selected brand names
      VendorIds: [],
      IsProductInOffer: null,
      IsStockAvailable: null,
      ThisWeek: null,
      ThisMonth: null,
      HighToLow: null,
      LowToHigh: null,
    }));

    // Call GetProductsByFilter with the updated filters, including the default price range
    GetProductsByFilter({
      ...filters,
      LowestPrice: null,
      HighestPrice: null,
      BrandNames: [], // Reset BrandNames
      IsProductInOffer: null,
      ThisWeek: null,
      ThisMonth: null,
      HighToLow: null,
      LowToHigh: null,
      IsStockAvailable: null,
    });
  };

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Header setLoginToken={setLoginToken} />
      <FilterPageComponent
        filtersByCategory={filtersByCategory}
        filters={filters}
        setFilters={setFilters}
        GetProductsByFilter={GetProductsByFilter}
        dataByCategory={dataByCategory}
        categoriesData={categoriesData}
        categorySelected={categorySelected}
        GetAllFiltersByCategory={GetAllFiltersByCategory}
        setCategorySelected={setCategorySelected}
        isAnyFilterActive={isAnyFilterActive}
        handleClearAll={handleClearAll}
      />
      <Footer />
    </div>
  );
};
export default FilterPage;
